import React, { memo, useEffect, useState, Suspense } from 'react';
import { Switch, Link, Route, Redirect, useRouteMatch } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import RouteWithInnerRoutes from '../../../app/components/RouteWithSubRoutes/RouteWithSubRoutes';
import SideBar from '../SideBar';
import IconButton from '../../../shared/components/IconButton';
import SVG from 'react-inlinesvg';
import Loading from '../../../app/components/Loading';
import { useTranslation } from 'react-i18next';
import map from 'lodash/map';
import styles from './entryPoint.module.scss';
import { angleLeftSVG } from '../../../shared/helpers/icons';
import { defaultPath as gpsSearchDefaultPath } from '../../../gpsSearch/routes';

const EntryPoint = withRouter(
    ({
        loggedUser,
        innerRoutes,
        config,
        loggedUser: { permisionEntities },
        changeConfigChildRoute,
        setUserLogin,
        signOut,
        location
    }) => {
        const { t } = useTranslation('home');
        const matchRoute = useRouteMatch(location.pathname);
        const [title, setTitle] = useState('');
        const [subTitle, setSubtitle] = useState('');
        const [backRoute, setBackRoute] = useState(null);
        const [goBack, setGoBack] = useState(false);
        const [route, setRoute] = useState('');

        const isCurrentRoute = (path, exact = false) =>
            exact ? matchRoute.path === path : matchRoute.path.includes(path) || String(path).includes(matchRoute.path);

        useEffect(() => {
            const currentPath = location.pathname;
            if (!currentPath.match(/\/stock\/(devices|gps|simcard)\/[^\/]+$/) && !currentPath.match(/\/activeServices\/detail\/[^\/]+$/)) {
                sessionStorage.setItem('previousRoute', currentPath);
            }
        }, [location.pathname]);

        useEffect(() => {
            innerRoutes.some(route => {
                if (isCurrentRoute(route.path)) {
                    changeConfigChildRoute(route);
        
                    const child = route.innerRoutes.find(({ path }) => isCurrentRoute(path, true));
        
                    const previousRoute = sessionStorage.getItem('previousRoute');
        
                    const imeiMatch = location.pathname.match(/\/stock\/devices\/(\d+)/);
                    if (imeiMatch) {
                        const imei = imeiMatch[1];
                        setTitle(`Dispositivo ${imei}`);
                        setBackRoute(previousRoute || '/stock/devices');
                    } else if (location.pathname.match(/\/stock\/gps\/\d+/)) {
                        const gpsId = location.pathname.split('/').pop();
                        setTitle(`GPS ${gpsId}`);
                        setBackRoute(previousRoute || '/stock/gps_devices');
                    } else if (location.pathname === '/stock/gps/new') {
                        setTitle('Agregar GPS');
                        setBackRoute(previousRoute);
                    } else if (location.pathname.match(/\/stock\/simcard\/.+/)) {
                        const iccid = location.pathname.split('/').pop();
                        setTitle(`Simcard ${iccid}`);
                        setBackRoute(previousRoute || '/stock/simcard');
                    } else if (location.pathname.match(/\/activeServices\/detail\/.+/)) {
                        const serviceId = location.pathname.split('/').pop();
                        setTitle('Detalle de servicio');
                        setBackRoute(previousRoute || '/activeServices');
                    } else {
                        setTitle(child?.title?.key ? `${t(route.title.key)} / ${t(child.title.key)}` : t(route.title.key));
                        setBackRoute(null);
                    }
        
                    setSubtitle(t(child && String(child.subTitle.key).length ? child.subTitle.key : route.subTitle.key));
        
                    return true;
                }
        
                return false;
            });

        }, [location, innerRoutes, changeConfigChildRoute, t]);
        

        return (
            <div className={styles.grid}>
                <SideBar
                    currentChildRoute={config.currentChildRoute}
                    changeConfigChildRoute={changeConfigChildRoute}
                    setUserLogin={setUserLogin}
                    loggedUser={loggedUser}
                    signOut={signOut}
                    locationPathName={location.pathname}
                />
                <div className={styles.main}>
                    <div className={styles.header}>
                        <div className={styles.content}>
                            <div className={styles.titleContent}>
                                {backRoute && (
                                    <div className={styles.icon}>
                                        <Link to={backRoute}>
                                            <IconButton>
                                                <SVG src={angleLeftSVG} />
                                            </IconButton>
                                        </Link>
                                    </div>
                                )}
                                <span className={styles.title}>{config.title || title}</span>
                            </div>
                            <span className={styles.subTitle}>{config.subtitle || subTitle}</span>
                        </div>
                    </div>
                    <div className={styles.wrapper}>
                        <Suspense fallback={<Loading theme />}>
                            <Switch>
                                {map(innerRoutes, (route, index) => (
                                    <RouteWithInnerRoutes key={index} {...route} />
                                ))}
                                {map(innerRoutes, (route, index) => (
                                    <RouteWithInnerRoutes key={index} {...route} />
                                ))}
                                <Route path="*">
                                    <Redirect to={gpsSearchDefaultPath} />
                                </Route>
                            </Switch>
                        </Suspense>
                    </div>
                </div>
            </div>
        );
    }
);

export default memo(EntryPoint);
